import { Form, useActionData, useNavigation } from 'react-router'
import { cn } from '#app/utils/misc.tsx'
import { Button } from './ui/button.tsx'
import { Icon } from './ui/icon.tsx'
import { InputText } from './ui/input-text.tsx'

interface ContactoAliadosFormProps {
	className?: string
	method?: 'POST' | 'GET'
	action?: string
	section?: 'home' | 'technology'
}

export function ContactoAliadosForm({
	className,
	method = 'POST',
	action,
	section = 'home',
}: ContactoAliadosFormProps) {
	const actionData = useActionData<{
		success?: boolean
		message?: string
		errors?: {
			empresa?: string[]
			telefono?: string[]
			email?: string[]
		}
	}>()

	const navigation = useNavigation()
	const isSubmitting = navigation.state === 'submitting'

	const SubmitButton = () => {
		switch (section) {
			case 'technology':
				return (
					<Button
						type="submit"
						variant="secondary"
						className="bg-[#E7F6FD] text-[#075980]"
						size="l"
						appearance="text"
						disabled={isSubmitting}
					>
						{isSubmitting ? 'Enviando...' : 'Enviar'}
						<Icon name="arrow-right" size="sm" className="ml-2 -rotate-90" />
					</Button>
				)
			default:
				return (
					<Button
						type="submit"
						variant="secondary"
						size="l"
						disabled={isSubmitting}
					>
						{isSubmitting ? 'Enviando...' : 'Enviar'}
						<Icon name="arrow-right" size="sm" className="ml-2 -rotate-90" />
					</Button>
				)
		}
	}

	return (
		<Form
			method={method}
			action={action}
			className={cn('flex flex-col gap-6', className)}
		>
			{/* Success Message */}
			{actionData?.success && (
				<div className="rounded-[12px] border border-green-200 bg-green-50 p-4">
					<div className="flex items-center gap-2">
						<Icon name="check" size="sm" className="text-green-600" />
						<p className="text-sm font-medium text-green-800">
							{actionData.message || '¡Mensaje enviado exitosamente!'}
						</p>
					</div>
				</div>
			)}

			{/* Error Message */}
			{actionData && !actionData.success && actionData.message && (
				<div className="rounded-[12px] border border-red-200 bg-red-50 p-4">
					<div className="flex items-center gap-2">
						<Icon
							name="question-mark-circled"
							size="sm"
							className="text-red-600"
						/>
						<p className="text-sm font-medium text-red-800">
							{actionData.message}
						</p>
					</div>
				</div>
			)}

			{/* Form Fields */}
			<div className="flex flex-col gap-3">
				{/* Campo Empresa */}
				<div className="w-full">
					<InputText
						name="empresa"
						label="Nombre de empresa"
						labelPosition="internal"
						required
						size="l"
						errorText={actionData?.errors?.empresa?.[0]}
						disabled={isSubmitting}
					/>
				</div>

				{/* Teléfono y Email en fila */}
				<div className="flex gap-4">
					<div className="flex-1">
						<InputText
							name="telefono"
							label="Teléfono"
							labelPosition="internal"
							required
							size="l"
							type="tel"
							errorText={actionData?.errors?.telefono?.[0]}
							disabled={isSubmitting}
						/>
					</div>
					<div className="flex-1">
						<InputText
							name="email"
							label="Email"
							labelPosition="internal"
							required
							size="l"
							type="email"
							errorText={actionData?.errors?.email?.[0]}
							disabled={isSubmitting}
						/>
					</div>
				</div>
			</div>

			{/* Submit Button */}
			<SubmitButton />
		</Form>
	)
}
